//because of circular dependencies we need to require these modules in a specific order
import "./code-block";
import "./code-block-types";
export default require("./components/block-scope").default;
